<template>
  <div>
    <!-- Botao de menu (mobile): abaixo de 960px o drawer vira temporario e some;
         este hamburguer flutuante e o unico jeito de reabrir a navegacao. -->
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      class="sidebar-fab"
      :class="moduleClass"
      fab
      small
      dark
      :aria-label="$t('sidebar.openMenu')"
      @click="drawer = !drawer"
    >
      <v-icon>fi-rr-menu-burger</v-icon>
    </v-btn>

    <v-navigation-drawer
      v-model="drawer"
      floating
      app
      mobile-breakpoint="960"
      class="sidebar-drawer"
      :class="moduleClass"
      :mini-variant-width="$vuetify.breakpoint.mdAndUp ? '4vw' : '12vw'"
      :mini-variant.sync="mini"
      :mini="mini"
    >
      <div class="sidebar-shell">
        <div class="sidebar-main">
          <v-list class="transparent" nav>
            <v-list-item class="mt-2">
              <v-img
                contain
                height="7vh"
                :src="
                  mini
                    ? require('@/assets/images/logo_pitch.webp')
                    : require('@/assets/icons/connect_logo_bar.svg')
                "
              />
            </v-list-item>
          </v-list>
          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('cockpit') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-house-chimney</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/cockpit`">
                <v-list-item-title>{{ $t("sidebar.home") }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- Item direto, não mais um grupo: os dois filhos ("Módulos" e
               "Certificados") apontavam para a MESMA rota, então o menu abria
               para oferecer uma escolha que não existia. -->
          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('curso') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-book-open-cover</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/curso`">
                <v-list-item-title>{{
                  $t("sidebar.materials")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- Card 86akqwmzy: treinamentos dos professores em aba própria. -->
          <v-list
            v-if="module === '/connect/professor'"
            class="d-flex align-center justify-start sidebar-menu-list"
          >
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('treinamentos') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-e-learning</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/treinamentos`">
                <v-list-item-title>{{
                  $t("sidebar.trainings")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- Card 17trt6jcyfb: so para tutor (alunos Autonomy). -->
          <v-list
            v-if="module === '/connect/professor' && isTutor"
            class="d-flex align-center justify-start sidebar-menu-list"
          >
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('exercicios') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-edit</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/exercicios`">
                <v-list-item-title>{{
                  $t("sidebar.autonomyStudents")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- O grupo trazia "Minhas Aulas", que levava para /agenda -- a
               mesma rota do item Agenda logo abaixo. Com o menu plano, cada
               destino aparece uma vez só, com um nome só. -->
          <v-list
            v-if="!isSoloCustomer"
            class="d-flex align-center justify-start sidebar-menu-list"
          >
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('turmas') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-users-alt</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/turmas`">
                <v-list-item-title>{{
                  $t("sidebar.classes")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- O grupo tinha um filho só ("Eventos"), para a mesma rota. -->
          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('agenda') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-calendar-clock</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/agenda`">
                <v-list-item-title>{{
                  $t("sidebar.schedule")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- Card 86akj8q08: plano de estudos, só para o aluno autônomo. -->
          <v-list
            v-if="isSoloCustomer"
            class="d-flex align-center justify-start sidebar-menu-list"
          >
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('plano-de-estudos') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-book-alt</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/plano-de-estudos`">
                <v-list-item-title>{{
                  $t("sidebar.studyPlan")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <!-- Card 17trt6jbffe: Mensagens (chat), com o total de não lidas. -->
          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('mensagens') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-badge
                  v-if="messagesUnread"
                  overlap
                  dense
                  color="red"
                  class="sidebar-badge"
                  :content="messagesUnread > 99 ? '99+' : messagesUnread"
                >
                  <v-icon>fi-rr-comments</v-icon>
                </v-badge>
                <v-icon v-else>fi-rr-comments</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/mensagens`">
                <v-list-item-title>{{
                  $t("sidebar.messages")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <v-list class="d-flex align-center justify-start sidebar-menu-list">
            <v-list-group
              class="sidebar-group"
              :class="{
                'sb-group--active':
                  isActive('financeiro') || isActive('pitch-coins'),
              }"
            >
              <template v-slot:activator>
                <v-list-item-avatar size="40" rounded>
                  <v-icon>fi-rr-wallet</v-icon>
                </v-list-item-avatar>
                <v-list-item-title>{{
                  $t("sidebar.finance")
                }}</v-list-item-title>
              </template>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon>fi-rr-receipt</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/financeiro`">
                  <v-list-item-title>{{
                    module === "/connect/aluno"
                      ? $t("sidebar.invoices")
                      : $t("sidebar.payments")
                  }}</v-list-item-title>
                </router-link>
              </v-list-item>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon>fi-rr-coins</v-icon>
                </v-list-item-avatar>
                <!-- Card 17trt6jd8uu: antes abria o Financeiro. Por path,
                     nunca por name (nomes de rota repetem entre aluno e
                     professor). -->
                <router-link :to="`${module}/pitch-coins`">
                  <v-list-item-title>{{
                    $t("sidebar.pitchCoins")
                  }}</v-list-item-title>
                </router-link>
              </v-list-item>
              <v-list-item custom class="d-flex align-center justify-start">
                <v-list-item-avatar size="40" rounded>
                  <v-icon>fi-rr-badge-percent</v-icon>
                </v-list-item-avatar>
                <router-link :to="`${module}/financeiro`">
                  <v-list-item-title>{{
                    $t("sidebar.promotions")
                  }}</v-list-item-title>
                </router-link>
              </v-list-item>
            </v-list-group>
          </v-list>

          <!-- Card 17trt6jfkw8: certificados, só para o aluno (o professor não vê). -->
          <v-list
            v-if="isStudent"
            class="d-flex align-center justify-start sidebar-menu-list"
          >
            <v-list-item
              class="sidebar-group d-flex align-center justify-start"
              :class="{ 'sb-item--active': isActive('certificados') }"
            >
              <v-list-item-avatar size="40" rounded>
                <v-icon>fi-rr-diploma</v-icon>
              </v-list-item-avatar>
              <router-link :to="`${module}/certificados`">
                <v-list-item-title>{{
                  $t("sidebar.certificates")
                }}</v-list-item-title>
              </router-link>
            </v-list-item>
          </v-list>

          <v-divider class="ma-0 pa-0"></v-divider>

          <v-list class="transparent mt-2 fill-width">
            <router-link :to="`${this.module}/notificacoes`" custom>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    v-bind="attrs"
                    v-on="on"
                    class="sidebar-nav-item d-flex align-center"
                    :class="{ 'sb-item--active': isActive('notificacoes') }"
                  >
                    <v-list-item-avatar rounded>
                      <v-badge
                        v-if="notificationsCount"
                        overlap
                        dense
                        :content="notificationsCount"
                        class="notification-badge sidebar-badge"
                        :class="{
                          'notification-badge--active': notificationsCount > 0,
                        }"
                      >
                        <v-icon
                          class="notification-bell"
                          :class="{
                            'notification-bell--blinking':
                              notificationsCount > 0,
                          }"
                          >fi-rr-bell</v-icon
                        >
                      </v-badge>
                      <v-icon v-else class="notification-bell"
                        >fi-rr-bell</v-icon
                      >
                    </v-list-item-avatar>
                    <v-list-item-content class="d-flex align-center">
                      <v-list-item-title>{{
                        $t("sidebar.notifications")
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>{{ $t("sidebar.notifications") }}</span>
              </v-tooltip>
            </router-link>
          </v-list>
        </div>

        <div class="sidebar-footer">
          <!-- Idioma e tema, um switch por linha na grade dos itens do
               rodape. O tema vale so no Connect logado (plugins/theme.js). -->
          <div class="sidebar-prefs" :class="{ 'sidebar-prefs--mini': mini }">
            <div class="sidebar-prefs__row">
              <language-switcher :mini="mini" />
            </div>
            <div class="sidebar-prefs__row">
              <theme-switcher :mini="mini" />
            </div>
          </div>
          <v-list class="transparent fill-width">
            <router-link :to="`${this.module}/perfil`" custom>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    v-bind="attrs"
                    v-on="on"
                    class="sidebar-nav-item sidebar-profile d-flex align-center"
                    :class="{ 'sb-item--active': isActive('perfil') }"
                  >
                    <span class="sidebar-profile__ring">
                      <span class="sidebar-profile__disc">
                        <img
                          v-if="avatarUrl"
                          :src="avatarUrl"
                          :alt="$t('sidebar.profilePhoto')"
                          class="sidebar-profile__img"
                        />
                        <span v-else class="sidebar-profile__initials">
                          {{ customerInitials }}
                        </span>
                      </span>
                    </span>
                    <v-list-item-content class="sidebar-profile__meta">
                      <v-list-item-title class="sidebar-profile__name">
                        {{ displayName }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="sidebar-profile__role">
                        {{ roleLabel }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <span>{{ $t("sidebar.viewProfile") }}</span>
              </v-tooltip>
            </router-link>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  v-bind="attrs"
                  v-on="on"
                  class="sidebar-nav-item d-flex align-center"
                  @click="logoff"
                >
                  <v-list-item-avatar size="40" rounded>
                    <v-icon>fi-rr-sign-out-alt</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sidebar.logout")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ $t("sidebar.logout") }}</span>
            </v-tooltip>
          </v-list>
        </div>
      </div>
    </v-navigation-drawer>
    <v-main>
      <slot />
    </v-main>
  </div>
</template>

<script>
import store from "@/store";
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import { NOTIFICATIONS_REFRESH_EVENT } from "@/shared/notificationEvents";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
import {
  applyTheme,
  hasStoredTheme,
  normalizeTheme,
  saveTheme,
  storedTheme,
} from "@/plugins/theme";
import { setLocale } from "@/plugins/i18n";
export default {
  name: "PitchEnglishHomeApplicationTemplate",

  components: { LanguageSwitcher, ThemeSwitcher },

  data() {
    return {
      // No desktop a barra e permanente (aberta); no celular comeca fechada e o
      // usuario abre pelo botao de menu.
      drawer: typeof window === "undefined" ? true : window.innerWidth >= 960,
      module: `/connect/${store.getters.module}`,
      mini: false,
      notificationsRefreshTimeout: null,
      refreshingNotifications: false,
      messagesUnreadTimer: null,
      refreshingMessages: false,
    };
  },

  watch: {
    // Ao trocar de pagina no celular, fecha o drawer temporario para revelar o
    // conteudo escolhido.
    $route() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    },
  },

  computed: {
    currentUser() {
      return this.$store.getters.user || {};
    },
    moduleClass() {
      return this.$store.getters.module === "professor"
        ? "sb--professor"
        : "sb--aluno";
    },
    roleLabel() {
      return this.$store.getters.module === "professor"
        ? this.$t("sidebar.teacher")
        : this.$t("sidebar.student");
    },
    displayName() {
      const name =
        this.currentUser.name ||
        this.currentUser.full_name ||
        this.$t("sidebar.myProfile");
      return String(name).trim();
    },
    avatarUrl() {
      return (
        this.currentUser.avatar ||
        this.currentUser.profilePicture ||
        this.$store.state.avatar ||
        null
      );
    },
    customerInitials() {
      const storedInitials = localStorage.getItem("initials");

      if (storedInitials) {
        return storedInitials;
      }

      const name = this.currentUser.name || this.currentUser.full_name || "";

      return String(name)
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase();
    },
    notificationsCount() {
      return this.$store.getters.notificationsCount;
    },
    messagesUnread() {
      return Number(this.$store.getters.messagesUnread?.total) || 0;
    },
    avatarFallbackColor() {
      return this.$store.getters.module === "professor"
        ? "secondary-500"
        : "primary-500";
    },
    // Aluno solo (preference ALONE = 1) nao passa por turmas/match: escondemos
    // o grupo "Turmas" do menu para esse perfil.
    isTutor() {
      return !!this.$store.getters.user?.tutor;
    },
    isStudent() {
      return this.$store.getters.module === "aluno";
    },
    isSoloCustomer() {
      const user = this.$store.getters.user;
      // preference e INT8 e chega como string ("1"): comparar o numero.
      return (
        this.$store.getters.module === "aluno" && Number(user?.preference) === 1
      );
    },
  },

  // O tema escolhido vale so aqui dentro: ao montar o Connect liga, ao sair
  // (logout, site publico) volta ao claro.
  created() {
    applyTheme(storedTheme(), this.$vuetify);
  },

  mounted() {
    this.ensurePreferenceIsKnown();
    this.applyUserLanguage();
    this.applyUserTheme();
    this.refreshNotificationsCount();
    window.addEventListener(
      NOTIFICATIONS_REFRESH_EVENT,
      this.scheduleNotificationsRefresh
    );
    // Card 17trt6jbffe: badge de Mensagens a cada 30 s, pausado com a aba
    // oculta (o servidor nao tem push).
    this.refreshMessagesUnread();
    this.messagesUnreadTimer = window.setInterval(
      this.refreshMessagesUnread,
      30000
    );
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },

  beforeDestroy() {
    applyTheme("light", this.$vuetify);
    if (this.messagesUnreadTimer) {
      window.clearInterval(this.messagesUnreadTimer);
    }
    document.removeEventListener("visibilitychange", this.onVisibilityChange);

    window.removeEventListener(
      NOTIFICATIONS_REFRESH_EVENT,
      this.scheduleNotificationsRefresh
    );

    if (this.notificationsRefreshTimeout) {
      window.clearTimeout(this.notificationsRefreshTimeout);
    }
  },

  methods: {
    // Card 86akfyjht: o menu decide o grupo "Turmas" pela `preference` do
    // store, e sessões abertas antes desta correção podem não tê-la. Sem isso,
    // o aluno sem professor continuaria vendo "Minhas Turmas" até o próximo
    // login. Só consulta quando o campo realmente falta.
    async ensurePreferenceIsKnown() {
      const user = this.$store.getters.user;

      if (this.$store.getters.module !== "aluno") return;
      if (!user || user.preference != null) return;

      try {
        const { data } = await pitchCustomerApi.showProfile();
        if (data?.preference == null) return;

        this.$store.commit("SET_USER", {
          ...user,
          preference: data.preference,
        });
      } catch {
        // O menu segue como está; não vale derrubar a navegação por isso.
      }
    },
    // O idioma fica salvo no usuario. O login ja aplica; aqui cobre a sessao
    // aberta antes desta versao, que nao tem o campo no store: busca no perfil
    // uma vez e guarda.
    async applyUserLanguage() {
      const user = this.$store.getters.user;
      if (!user) return;

      if (user.language) {
        setLocale(user.language, this.$vuetify);
        return;
      }

      try {
        const api =
          this.$store.getters.module === "professor"
            ? pitchPartnerApi
            : pitchCustomerApi;
        const { data } = await api.showProfile();
        const language = data?.language || "pt";
        setLocale(language, this.$vuetify);
        this.$store.commit("SET_USER", {
          ...(this.$store.getters.user || {}),
          language,
        });
      } catch {
        // Sem o perfil, a tela fica no idioma que ja estava.
      }
    },
    // O tema fica salvo no usuario, como o idioma. O login ja grava; aqui
    // cobre a sessao aberta antes desta versao, sem o campo no store. Quem ja
    // tinha escolhido neste navegador (o tema nasceu so local) leva a escolha
    // para o usuario; senao vale o que esta no perfil.
    async applyUserTheme() {
      const user = this.$store.getters.user;
      if (!user) return;

      if (user.theme) {
        const theme = normalizeTheme(user.theme);
        saveTheme(theme);
        applyTheme(theme, this.$vuetify);
        return;
      }

      const api =
        this.$store.getters.module === "professor"
          ? pitchPartnerApi
          : pitchCustomerApi;

      try {
        let theme;
        if (hasStoredTheme()) {
          theme = storedTheme();
          await api.updateTheme(theme);
        } else {
          const { data } = await api.showProfile();
          theme = normalizeTheme(data?.theme);
          saveTheme(theme);
          applyTheme(theme, this.$vuetify);
        }
        this.$store.commit("SET_USER", {
          ...(this.$store.getters.user || {}),
          theme,
        });
      } catch {
        // Sem a API, a tela fica no tema que ja estava neste navegador.
      }
    },
    onVisibilityChange() {
      if (document.visibilityState === "visible") this.refreshMessagesUnread();
    },
    async refreshMessagesUnread() {
      if (
        this.refreshingMessages ||
        !this.$store.getters.token ||
        document.visibilityState === "hidden"
      ) {
        return;
      }
      const currentModule = this.$store.getters.module;
      if (!currentModule) return;

      this.refreshingMessages = true;
      try {
        const api =
          currentModule === "professor" ? pitchPartnerApi : pitchCustomerApi;
        const { data } = await api.getMessagesUnread();
        this.$store.commit("SET_MESSAGES_UNREAD", data);
      } catch (_error) {
        // Badge desatualizado nao derruba a navegacao.
      } finally {
        this.refreshingMessages = false;
      }
    },
    isActive(suffix) {
      const target = `${this.module}/${suffix}`;
      return (
        this.$route.path === target || this.$route.path.startsWith(`${target}/`)
      );
    },
    scheduleNotificationsRefresh() {
      if (this.notificationsRefreshTimeout) {
        window.clearTimeout(this.notificationsRefreshTimeout);
      }

      this.notificationsRefreshTimeout = window.setTimeout(() => {
        this.refreshNotificationsCount();
      }, 250);
    },
    async refreshNotificationsCount() {
      if (this.refreshingNotifications || !this.$store.getters.token) {
        return;
      }

      const currentModule = this.$store.getters.module;

      if (!currentModule) {
        return;
      }

      this.refreshingNotifications = true;

      try {
        const api =
          currentModule === "professor" ? pitchPartnerApi : pitchCustomerApi;
        const res = await api.getUnreadNotificationsCount();
        this.$store.dispatch("setNotificationsCount", res.data?.count || 0);
      } catch (_error) {
        return null;
      } finally {
        this.refreshingNotifications = false;
      }
    },
    logoff() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("module");
      this.$router.push({
        path: "/connect",
      });
    },
  },
};
</script>

<style scoped>
/* Botao de menu flutuante (mobile). Acento por modulo, canto superior esquerdo,
   acima do conteudo. Quando o drawer abre, ele cobre este botao (o usuario
   passa a usar a propria barra). */
.sidebar-fab {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 6;
  background-color: var(--dk-pink, #e8276f) !important;
}
.sidebar-fab.sb--professor {
  background-color: var(--dk-grape, #a826e1) !important;
}

/* Tokens do sistema "a Escada". Acento por modulo: rosa (aluno) / uva
   (professor), aplicado via .sb--aluno / .sb--professor no drawer. */
.sidebar-drawer {
  --sb-ink: var(--dk-ink, #231a2e);
  --sb-muted: var(--dk-muted, #6b6472);
  --sb-paper: var(--dk-paper, #fbf7fa);
  --sb-line: rgba(var(--dk-ink-rgb, 35, 26, 46), 0.09);
  --sb-accent: var(--dk-pink, #e8276f);
  --sb-accent-2: var(--dk-pink-deep, #b51f57);
  --sb-accent-soft: rgba(232, 39, 111, 0.1);
  background: var(--dk-surface, #fff) !important;
  border-right: 1px solid var(--sb-line);
  color: var(--sb-ink);
}
.sidebar-drawer.sb--professor {
  --sb-accent: var(--dk-grape, #a826e1);
  --sb-accent-2: var(--dk-grape-deep, #7d1baa);
  --sb-accent-soft: rgba(168, 38, 225, 0.1);
}

.sidebar-drawer::v-deep a {
  text-decoration: none;
  color: inherit;
}

.sidebar-shell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.sidebar-main {
  flex: 1 1 auto;
}

.sidebar-footer {
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid var(--sb-line);
}

/* Cada switch numa linha com a geometria dos itens do rodape (48px, 8px de
   margem, 12px de padding). O botao do switch, do lado esquerdo, fica com o
   centro na coluna dos icones (20px dentro do slot de 40px): 4px de recuo
   + 3px de folga + metade dos 26px do botao. */
.sidebar-prefs__row {
  display: flex;
  align-items: center;
  min-height: 48px;
  margin: 0 8px 4px;
  padding: 0 12px 0 16px;
}

.sidebar-prefs--mini .sidebar-prefs__row {
  justify-content: center;
  padding: 0;
}

.sidebar-drawer::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-menu-list {
  width: 100%;
}

.sidebar-group {
  width: 100%;
}

.sidebar-group::v-deep .v-list-group__header {
  width: 100%;
}

.sidebar-group::v-deep .v-list-group__header .v-list-item {
  width: 100%;
}

.sidebar-group::v-deep .v-list-group__header .v-list-item__content {
  flex: 1 1 auto;
  min-width: 0;
}

.sidebar-group::v-deep .v-list-group__header .v-list-item__icon:last-child {
  margin-left: auto;
  padding-right: 8px;
}

/* Normaliza o alinhamento dos icones do menu: mesmo tamanho de avatar,
   mesma margem e conteudo centralizado. Os icones antigos usavam height="2vh"
   (relativo a viewport) e alguns v-icon com prop `height` invalida, o que
   deixava os icones com tamanhos diferentes e desalinhados. */
.sidebar-drawer::v-deep .v-list-item__avatar {
  height: 40px !important;
  width: 40px !important;
  min-width: 40px !important;
  margin-top: 2px !important;
  margin-bottom: 2px !important;
  margin-right: 12px !important;
  justify-content: center !important;
  align-self: center !important;
}

/* Icones (imagens svg e mdi) uniformizados em 22px e centralizados.
   A foto de perfil (sidebar-profile-avatar) e preservada em tamanho cheio. */
.sidebar-drawer::v-deep
  .v-list-item__avatar:not(.sidebar-profile-avatar)
  .v-image,
.sidebar-drawer::v-deep .v-list-item__avatar .v-icon {
  height: 22px !important;
  width: 22px !important;
  font-size: 22px !important;
  margin: 0 auto !important;
}

/* Alinha a grade do menu: o "Inicio" e um v-list-item simples, os demais sao
   headers de v-list-group. Sem normalizar, cada um usa min-height/padding
   diferentes e o icone do Inicio cai fora da coluna. Aqui forcamos a mesma
   altura minima e o mesmo recuo horizontal para itens e headers. */
.sidebar-menu-list::v-deep > .v-list-item,
.sidebar-menu-list::v-deep .v-list-group__header {
  min-height: 48px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  margin: 2px 8px !important;
  border-radius: 12px;
  transition: background 0.16s ease;
}

/* Hover discreto: mesma linguagem de pill em papel. */
.sidebar-menu-list::v-deep > .v-list-item:hover,
.sidebar-menu-list::v-deep .v-list-group__header:hover {
  background: var(--sb-paper);
}

/* Item / secao ativo: pill no acento suave + rail no acento (no da Escada). */
.sb-item--active,
.sb-group--active::v-deep > .v-list-group__header {
  background: var(--sb-accent-soft) !important;
  box-shadow: inset 3px 0 0 var(--sb-accent);
}
.sb-item--active ::v-deep .v-list-item__title,
.sb-group--active::v-deep > .v-list-group__header .v-list-item__title {
  color: var(--sb-accent);
  font-weight: 700;
}

/* ---------- Iconografia e rotulos unificados ---------- */
/* Rotulos em repouso: peso e cor do sistema. */
.sidebar-drawer::v-deep .v-list-item__title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--sb-ink);
  letter-spacing: 0;
}

/* Icones mdi: muted em repouso, acento no hover e no ativo. */
.sidebar-drawer::v-deep .v-list-item__avatar .v-icon {
  color: var(--sb-muted);
  transition: color 0.16s ease;
}
.sidebar-menu-list::v-deep > .v-list-item:hover .v-icon,
.sidebar-menu-list::v-deep .v-list-group__header:hover .v-icon,
.sidebar-drawer::v-deep .sidebar-nav-item.v-list-item:hover .v-icon {
  color: var(--sb-accent);
}
.sb-item--active ::v-deep .v-list-item__avatar .v-icon,
.sb-group--active::v-deep > .v-list-group__header .v-list-item__avatar .v-icon {
  color: var(--sb-accent);
}

/* Seta de expandir dos grupos na mesma paleta. */
.sidebar-group::v-deep .v-list-group__header .v-list-item__icon .v-icon {
  color: var(--sb-muted);
}
.sb-group--active::v-deep > .v-list-group__header .v-list-item__icon .v-icon {
  color: var(--sb-accent);
}

/* Divisor como hairline do sistema. */
.sidebar-main::v-deep .v-divider {
  border-color: var(--sb-line);
}

/* Zera margens laterais herdadas do avatar para o icone comecar sempre no
   mesmo x (o espacamento ate o texto vem do margin-right definido acima). */
.sidebar-menu-list::v-deep .v-list-item__avatar {
  margin-left: 0 !important;
}

/* Itens do rodape (Notificacoes, Perfil, Logout) na mesma grade dos demais:
   mesma altura, mesmo recuo horizontal e sem os paddings/max-height antigos. */
.sidebar-drawer::v-deep .sidebar-nav-item.v-list-item {
  min-height: 48px !important;
  max-height: none !important;
  margin: 0 8px 4px !important;
  padding: 0 12px !important;
  border-radius: 12px;
  transition: background 0.16s ease;
}
.sidebar-drawer::v-deep .sidebar-nav-item.v-list-item:hover {
  background: var(--sb-paper);
}

/* O conteudo (titulo) desses itens tambem sem padding vertical extra, para o
   texto centralizar igual ao menu principal. */
.sidebar-drawer::v-deep .sidebar-nav-item .v-list-item__content {
  padding: 0 !important;
}

/* Sino de notificacao um pouco maior que os demais icones (outlined). */
.sidebar-drawer::v-deep .v-list-item__avatar .notification-bell.v-icon {
  font-size: 26px !important;
}

/* Icones UIcons (regular rounded, o mesmo traco do administrativo). O glifo
   ocupa a caixa inteira, ao contrario do mdi, entao 22px pesaria: 19px fica
   com o mesmo peso visual. O sino segue um pouco maior. */
.sidebar-drawer::v-deep .v-list-item__avatar .v-icon[class*="fi-rr-"] {
  font-size: 19px !important;
  line-height: 1;
}
.sidebar-drawer::v-deep
  .v-list-item__avatar
  .notification-bell.v-icon[class*="fi-rr-"] {
  font-size: 21px !important;
}

/* Contadores (Mensagens e Notificacoes) no canto superior direito do icone,
   so encostando no glifo. O `overlap` do Vuetify centra o numero 12px para
   dentro, o que cobria metade do icone de 19-21px; o anel branco separa o
   numero do traco. */
.sidebar-drawer::v-deep .v-list-item__avatar {
  overflow: visible;
}
.sidebar-badge::v-deep .v-badge__badge {
  bottom: calc(100% - 8px) !important;
  left: calc(100% - 6px) !important;
  height: 18px;
  min-width: 18px;
  padding: 0 5px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  box-shadow: 0 0 0 2px var(--dk-surface, #fff);
}

.notification-badge--active::v-deep .v-badge__badge {
  animation: notificationBadgeBlink 1.2s ease-in-out infinite;
}

.notification-bell--blinking {
  animation: notificationBellBlink 1.2s ease-in-out infinite;
  transform-origin: center;
}

/* ---------- Perfil (rodape): avatar circular com anel no acento ---------- */
.sidebar-profile__ring {
  display: inline-flex;
  padding: 2px;
  margin-right: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--sb-accent), var(--sb-accent-2));
}
.sidebar-profile__disc {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--dk-surface, #fff);
  border: 2px solid var(--dk-surface, #fff);
}
.sidebar-profile__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.sidebar-profile__initials {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--sb-accent);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  text-transform: uppercase;
}
.sidebar-profile__meta {
  padding: 0 !important;
  min-width: 0;
}
.sidebar-profile__name {
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.25;
  color: var(--sb-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebar-profile__role.v-list-item__subtitle {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--sb-accent) !important;
}

/* No modo mini so o disco aparece; remove o respiro lateral do texto. */
.sidebar-drawer.v-navigation-drawer--mini-variant .sidebar-profile__ring {
  margin-right: 0;
}

@keyframes notificationBellBlink {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.35;
    transform: scale(1.08);
  }
}

@keyframes notificationBadgeBlink {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.12);
  }
}
</style>
